import React from "react";
import Container from "./Container";
import { Modal, TextField, Typography, Button, Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import { useGlobalDataContext } from "../../Context/AppGlobalData";

const ShippingInstructionModal = (props) => {
  const { shipmentInstruction, setShipmentInstruction } =
    useGlobalDataContext();
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Container
        position="absolute"
        top="25%"
        left="35%"
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          background: "#D2E0E8",
          height: "345px",
          width: "650px",
          borderRadius: "10px",
        }}
      >
        <Container
          className="ixPopupHeader"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderRadius: "10px",
            background: "#D2E0E8",
            height: "60px",
          }}
        >
          <Typography
            className="ixPopupHeaderTitle"
            sx={{ fontWeight: "bolder", margin: "10px", color: "black" }}
          >
            Shipping Instruction
          </Typography>
          <Button
            onClick={props.onClose}
            sx={{ margin: "5px" }}
            styletype="icon"
            className="ixButtonPopupHeader"
          >
            <ClearIcon />
          </Button>
        </Container>
        <TextField
          className="ixPopupContainer"
          sx={{
            height: "fit-content",
            width: "600px",
            margin: "0px 25px",
            // border: "2px solid #5B7A8F",
            padding:"0px !important",
            "& .MuiOutlinedInput-root ":{
              padding: "4px!important",
         
              // paddingLeft: "5px!important"
              
      }
          }}
          rows="6.5"
          multiline
          value={shipmentInstruction}
          onChange={(e) => setShipmentInstruction(e.target.value)}
        />
        <Box
          className="ixPopupFooter"
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            styletype="icon"
            onClick={props.onClose}
            sx={{ margin: "15px" }}
            className="ixButtonPopup"
          >
            <SaveIcon />
          </Button>
        </Box>
      </Container>
    </Modal>
  );
};
export default ShippingInstructionModal;
